// Centralized routes for the FromPostbox project creation flow
export const POSTBOX_ROUTES = {
  intro: '/projects/postbox/new',
  post: '/projects/postbox/post',
  team: '/projects/postbox/team',
  build: '/projects/postbox/build',
  feed: '/home',
};
